import { typedRequest } from '../utils/httpClientTs';
import {
  Newsfeed,
  NewsFeedDetail,
  NewsFeedCreateRequest,
} from '../types/newsfeed';

export const getNewsfeeds = async (): Promise<Newsfeed[]> => {
  return typedRequest<Newsfeed[]>({
    url: '/newsfeeds/',
    method: 'GET',
  });
};

export const getNewsfeedById = async (id: string): Promise<NewsFeedDetail> => {
  return typedRequest<NewsFeedDetail>({
    url: `/newsfeeds/${id}`,
    method: 'GET',
  });
};

export const createNewsfeed = async (
  data: Partial<Newsfeed>
): Promise<Newsfeed> => {
  return typedRequest<Newsfeed>({
    url: '/newsfeeds',
    method: 'POST',
    data: data,
  });
};

export const createNewsfeedDetail = async (
  data: NewsFeedCreateRequest
): Promise<NewsFeedCreateRequest> => {
  return typedRequest<NewsFeedCreateRequest>({
    url: '/newsfeeds/',
    method: 'POST',
    data: data,
  });
};

export const updateNewsfeed = async (params: {
  id: string;
  data: Partial<NewsFeedDetail>;
}): Promise<NewsFeedDetail> => {
  return typedRequest<NewsFeedDetail>({
    url: `/newsfeeds/${params.id}`,
    method: 'PUT',
    data: params.data,
  });
};

export const deleteNewsfeed = async (id: string): Promise<void> => {
  return typedRequest<void>({
    url: `/newsfeeds/${id}`,
    method: 'DELETE',
  });
};
